<template>
  <header class="admin-mobile-header">
    <button
      ref="menuButton"
      type="button"
      class="admin-mobile-header__menu admin-button--ghost"
      aria-controls="admin-mobile-drawer"
      :aria-expanded="drawerOpen"
      @click="$emit('toggle-drawer')"
    >
      <i class="fa fa-bars" aria-hidden="true"></i>
      <span class="sr-only">Navigation öffnen</span>
    </button>
    <router-link
      :to="{ name: 'Admincenter' }"
      class="admin-mobile-header__home"
      aria-label="Admin Center öffnen"
    >
      <div class="admin-mobile-header__title">
        <span>Administration</span>
        <strong>{{ title || "Übersicht" }}</strong>
      </div>
      <img src="@/assets/casplogo.png" alt="" class="admin-mobile-header__logo" />
    </router-link>
  </header>
</template>

<script>
export default {
  name: "AdminMobileHeader",
  props: {
    title: {
      type: String,
      default: "",
    },
    drawerOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggle-drawer"],
};
</script>
